// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.Details = M.View.Details || {};

/**
 * Renders a list of Greeting links.
 *
 * TODO: Extend from M.View.Picker
 */
M.View.ProductDetails.GreetingPicker = Backbone.View.extend({
  tagName: 'ul',
  className: 'greetingPicker',
  template: M.Template.ProductDetail.GreetingPicker,
  events: {
    'click .greetingOption': 'greetingOptionClick'
  },

  initialize: function() {
    var that = this;

    if (!this.collection) {
      M.required(this.options.greetingOptionsJson);
      this.collection = new M.Collection.ProductDetails.Greetings(
        this.options.greetingOptionsJson);
    }

    // TODO: Horizontal list template version
    if (this.options.template == 'horizontal') {
      this.template = M.Template.ProductDetails.GreetingPickerHorizontal;
    }
  },

  render: function() {
    this.$el = $(this.el);
    this.$el.empty();

    var templateVariables = {
      greetings: this.collection.models
    };
    this.$el.html(this.template(templateVariables));
    return this;
  },

  /**
   * Select the first option. (without triggering a click event)
   */
  selectById: function(id) {
    this.deSelect();
    var $greetingOption = $(this.$el.find('.greetingOption[data-id=' + id + ']'));
    $greetingOption.addClass('active');
    this.collection.select(this.collection.get(id));
  },

  /**
   * Select the first option. (without triggering a click event)
   */
  selectFirst: function() {
    this.deSelect();
    $(this.$el.find('.greetingOption')[0]).addClass('active');
    this.collection.select(this.collection.models[0]);
  },

  /**
   * Deselect any selected options.
   */
  deSelect: function() {
    this.$el.find('.greetingOption').removeClass('active');
    this.collection.select(null);
  },

  greetingOptionClick: function(e) {
    var previousGreeting = this.collection.getSelected();
    this.deSelect();
    var clickedElement = $(e.currentTarget);
    clickedElement.addClass('active');
    var selectedModel = this.collection.get(clickedElement.data('id'));
    this.collection.select(selectedModel);
    this.trigger('greeting_option_clicked', previousGreeting);
  }
});
